<template>
	<div>
		<div id="table-container">
			<table class="table table-hover ui-table">
				<thead>
					<tr>
						<th class="align-middle ts-whitespace-no-wrap text-center" rowspan="2">
							{{ $t('administration.employee.employeeDailyTimescan.branch') }}
						</th>
						<th class="align-middle ts-whitespace-no-wrap text-center" rowspan="2">
							{{ $t('administration.employee.employeeDailyTimescan.no') }}
						</th>
						<th class="align-middle ts-whitespace-no-wrap" rowspan="2">
							{{
								$t('administration.employee.employeeDailyTimescan.employeeId')
							}}
						</th>
						<th class="align-middle ts-whitespace-no-wrap" rowspan="2">
							{{
								$t(
									'administration.employee.employeeDailyTimescan.employeeName'
								)
							}}
						</th>
						<th class="align-middle ts-whitespace-no-wrap" rowspan="2">
							{{
								$t(
									'administration.employee.employeeDailyTimescan.position'
								)
							}}
						</th>
						<th class="align-middle ts-whitespace-no-wrap" rowspan="2">
							{{
								$t(
									'administration.employee.employeeDailyTimescan.department'
								)
							}}
						</th>
						<th class="align-middle ts-whitespace-no-wrap" rowspan="2">
							{{ $t('administration.employee.employeeDailyTimescan.shift') }}
						</th>
						<th class="align-middle ts-whitespace-no-wrap text-center" rowspan="2">
							{{ $t('administration.employee.employeeDailyTimescan.date') }}
						</th>
						<th class="align-middle ts-whitespace-no-wrap text-center" rowspan="2">
							{{ $t('administration.employee.employeeDailyTimescan.status') }}
						</th>
						<th class="align-middle ts-whitespace-no-wrap text-center" rowspan="2">
							{{ $t('administration.employee.employeeDailyTimescan.scannedOtherBranch') }}
						</th>
						<th class="text-center" colspan="5">1</th>
						<th class="text-center" colspan="5">2</th>
						<th class="text-center" v-show="enables === true" colspan="5">3</th>
						<th class="align-middle ts-whitespace-no-wrap text-center" rowspan="2">
							{{
								$t('administration.employee.employeeDailyTimescan.action')
							}}
						</th>
					</tr>
					<tr>
						<th class="ts-whitespace-no-wrap text-center">
							{{
								$t('administration.employee.employeeDailyTimescan.checkIn')
							}}
						</th>
						<th class="ts-whitespace-no-wrap text-center">
							{{
								$t('administration.employee.employeeDailyTimescan.status')
							}}
						</th>
						<th class="ts-whitespace-no-wrap text-center">
							{{
								$t('administration.employee.employeeDailyTimescan.checkOut')
							}}
						</th>
						<th class="ts-whitespace-no-wrap text-center">
							{{
								$t('administration.employee.employeeDailyTimescan.totalHours')
							}}
						</th>
						<th class="ts-whitespace-no-wrap text-center">
							{{
								$t('administration.employee.employeeDailyTimescan.lateMinutes')
							}}
						</th>
						<th class="ts-whitespace-no-wrap text-center">
							{{
								$t('administration.employee.employeeDailyTimescan.checkIn')
							}}
						</th>
						<th class="ts-whitespace-no-wrap text-center">
							{{
								$t('administration.employee.employeeDailyTimescan.status')
							}}
						</th>
						<th class="ts-whitespace-no-wrap text-center">
							{{
								$t('administration.employee.employeeDailyTimescan.checkOut')
							}}
						</th>
						<th class="ts-whitespace-no-wrap text-center">
							{{
								$t('administration.employee.employeeDailyTimescan.totalHours')
							}}
						</th>
						<th class="ts-whitespace-no-wrap text-center">
							{{
								$t('administration.employee.employeeDailyTimescan.lateMinutes')
							}}
						</th>
						<th class="ts-whitespace-no-wrap text-center" v-show="enables === true">
							{{
								$t('administration.employee.employeeDailyTimescan.checkIn')
							}}
						</th>
						<th class="ts-whitespace-no-wrap text-center" v-show="enables === true">
							{{
								$t('administration.employee.employeeDailyTimescan.status')
							}}
						</th>
						<th class="ts-whitespace-no-wrap text-center" v-show="enables === true">
							{{
								$t('administration.employee.employeeDailyTimescan.checkOut')
							}}
						</th>
						<th class="ts-whitespace-no-wrap text-center" v-show="enables === true">
							{{
								$t('administration.employee.employeeDailyTimescan.totalHours')
							}}
						</th>
						<th class="ts-whitespace-no-wrap text-center" v-show="enables === true">
							{{
								$t('administration.employee.employeeDailyTimescan.lateMinutes')
							}}
						</th>
					</tr>
					<tr v-if="loading == true">
						<th colspan="5" class="table-data-loading">
							<div class="table-data-loading__sliders">
								<div class="table-data-loading__line"></div>
								<div class="table-data-loading__subline table-data-loading__subline__inc"></div>
								<div class="table-data-loading__subline table-data-loading__subline__dec"></div>
							</div>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(record, index) in resources" :key="index">
						<td class="ts-whitespace-no-wrap">
							{{ record.employee.branch ? (record.employee.branch ?
								record.employee.branch.branch_name_en : '') :
								'' }}
						</td>
						<td class="ts-whitespace-no-wrap text-center">
							{{ index + 1 }}
						</td>
						<td class="ts-whitespace-no-wrap">
							{{ record.employee ? record.employee.emp_id : '' }}
						</td>
						<td class="ts-whitespace-no-wrap">
							{{
								record.employee
									? record.employee.name_en + '|' + (record.employee.name_kh ? record.employee.name_kh :
										'N/A')
									: ''
							}}
						</td>
						<td class="ts-whitespace-no-wrap">
							{{ record.employee.position ? (record.employee.position ?
								record.employee.position.pos_name_en : '') :
								'' }}
						</td>
						<td class="ts-whitespace-no-wrap">
							{{ record.employee.department ? (record.employee.department ?
								record.employee.department.department_name_en : '') :
								'' }}
						</td>
						<td class="ts-whitespace-no-wrap">
							{{
								record.shift
									? record.shift.shift_name +
									' (' +
									record.shift.shift_type +
									')'
									: ''
							}}
						</td>
						<td class="ts-whitespace-no-wrap text-center">
							{{ record.att_date }}
						</td>
						<td class="ts-whitespace-no-wrap text-center">
							{{ record.att_status }}
						</td>
						<td class="ts-whitespace-no-wrap">
							{{ record.scanned_other_branch }}
						</td>
						<td class="ts-whitespace-no-wrap text-center" :class="record.att_pnt_status
							? (record.att_pnt_status.toLowerCase() == 'late'
								? 'ts-text-red-500'
								: '')
							: ''
							">
							{{ tConvert(record.t1) }}
						</td>
						<td class="ts-whitespace-no-wrap text-center">
							{{ tConvert(record.att_pnt_status) }}
						</td>
						<td class="ts-whitespace-no-wrap text-center">
							{{ tConvert(record.t2) }}
						</td>
						<td class="ts-whitespace-no-wrap text-center">
							{{ record.total_hour1 }}
						</td>
						<td class="ts-whitespace-no-wrap text-center">
							{{ firstLate(record) }}
						</td>
						<td class="ts-whitespace-no-wrap text-center" :class="record.att_pnt_status_2
							? (record.att_pnt_status_2.toLowerCase() == 'late'
								? 'ts-text-red-500'
								: '')
							: ''
							">
							{{ tConvert(record.t3) }}
						</td>
						<td class="ts-whitespace-no-wrap text-center">
							{{ tConvert(record.att_pnt_status_2) }}
						</td>
						<td class="ts-whitespace-no-wrap text-center">
							{{ tConvert(record.t4) }}
						</td>
						<td class="ts-whitespace-no-wrap text-center">
							{{ record.total_hour2 }}
						</td>
						<td class="ts-whitespace-no-wrap text-center">
							{{ secondLate(record) }}
						</td>
						<td class="ts-whitespace-no-wrap text-center" :class="record.att_pnt_status_3
							? (record.att_pnt_status_3.toLowerCase() == 'late'
								? 'ts-text-red-500'
								: '')
							: ''
							" v-show="enables === true">
							{{ tConvert(record.t5) }}
						</td>
						<td class="ts-whitespace-no-wrap text-center" v-show="enables === true">
							{{ tConvert(record.att_pnt_status_3) }}
						</td>
						<td class="ts-whitespace-no-wrap text-center" v-show="enables === true">
							{{ tConvert(record.t6) }}
						</td>
						<td class="ts-whitespace-no-wrap text-center" v-show="enables === true">
							{{ record.total_hour3 }}
						</td>
						<td class="ts-whitespace-no-wrap text-center" v-show="enables === true">
							{{ thirdLate(record) }}
						</td>
						<td class="text-center ts-whitespace-no-wrap">
							<a href="#" title="Edit" class="mr-2 text-primary" @click.prevent="edit(record)">
								<i class="fas fa-edit"></i>
							</a>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import httpClient from '@/http-client'
import FormEdit from './edit.vue'

export default {
	name: 'detail',
	data() {
		return {
			loading: false,
			enables: false,
			showForm: false
		}
	},
	created() {
		// this.loadData()
	},
	computed: {
		...mapState('employeeDailyTimescan', ['resources']),
		...mapGetters('employeeDailyTimescan', ['tConvert'])
	},
	methods: {
		loadData() {
			httpClient.get('/api/attendance-settings')
				.then(response => {
					this.enables = response.data.data.enable_staff_scan
				})
		},


		firstLate(record) {
			var a = record.t1;
			var b = record.first_in;
			var late = new Date("01-01-2017 " + a + ":00").getHours();
			var lateMinutes = new Date("01-01-2017 " + a + ":00").getMinutes();
			var time_in = new Date("01-01-2017 " + b + ":00").getHours();
			var timeMinute = new Date("01-01-2017 " + b + ":00").getMinutes();
			var diffHour = late - time_in ? late - time_in : '00';
			var diffMinute = lateMinutes - timeMinute ? lateMinutes - timeMinute : '00';
			if (diffHour >= 0 && diffMinute >= 0) {
				return ("0" + diffHour).slice(-2) + ':' + ("0" + diffMinute).slice(-2);
			}
			return '00:00';
		},
		secondLate(record) {
			var a = record.t3;
			var b = record.second_in;
			var late = new Date("01-01-2017 " + a + ":00").getHours();
			var lateMinutes = new Date("01-01-2017 " + a + ":00").getMinutes();
			var time_in = new Date("01-01-2017 " + b + ":00").getHours();
			var timeMinute = new Date("01-01-2017 " + b + ":00").getMinutes();
			var diffHour = late - time_in ? late - time_in : '00';
			var diffMinute = lateMinutes - timeMinute ? lateMinutes - timeMinute : '00';
			if (diffHour >= 0 && diffMinute >= 0) {
				return ("0" + diffHour).slice(-2) + ':' + ("0" + diffMinute).slice(-2);
			}
			return '00:00';
		},
		thirdLate(record) {
			var a = record.t5;
			var b = record.third_in;
			var late = new Date("01-01-2017 " + a + ":00").getHours();
			var lateMinutes = new Date("01-01-2017 " + a + ":00").getMinutes();
			var time_in = new Date("01-01-2017 " + b + ":00").getHours();
			var timeMinute = new Date("01-01-2017 " + b + ":00").getMinutes();
			var diffHour = late - time_in ? late - time_in : '00';
			var diffMinute = lateMinutes - timeMinute ? lateMinutes - timeMinute : '00';
			if (diffHour >= 0 && diffMinute >= 0) {
				return ("0" + diffHour).slice(-2) + ':' + ("0" + diffMinute).slice(-2);
			}
			return '00:00';
		},

		edit(record) {
			this.showFormEdit(record)
		},
		showFormEdit(data) {
			const modal = this.$modal.show(
				FormEdit,
				{
					editData: data,
					onUpdated: () => {
						this.$emit('fetch')
					}
				},
				{
					height: 'auto',
					scrollable: true,
					clickToClose: false,
					width: '30%',
					draggable: '.form-header',
				}
			)
		}
	},
}
</script>
<style scoped>
.no-padding-top {
	padding: 0 1rem 1rem 1rem;
}

#table-container {
	min-height: 60vh;
	overflow-y: scroll;
}

table>tbody>tr td {
	vertical-align: middle;
}

.table>thead>tr>th {
	border: 1px solid #b6c2c9;
	vertical-align: middle;
}

::-webkit-scrollbar {
	height: 8px;
	width: 3px;
	/* Remove scrollbar space */
	background: #ffff;
	/* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
	border-radius: 4px;
	background: #e5e7e7;
}

div::-webkit-scrollbar-thumb:hover {
	background: #b7b7b8;
}
</style>
